import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export function createStore () {
	return new Vuex.Store({
		state: {
			isAdmin: false,
			adminEmail: '',
			status: '',
			token: '',
			user : {},

			activeType: null,
			itemsPerPage: 20,
			items: {/* [id: number]: Item */},
			users: {/* [id: string]: User */},
			lists: {
				top: [/* number */],
				new: [],
				show: [],
				ask: [],
				job: []
			}
		},
		actions,
		mutations,
		getters
	})
}



// WEBPACK FOOTER //
// src/store/index.js